<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['d-flex', getSelectedDEV && 'dev-selected-component']">
    <v-file-input
      v-if="!isThumbnail"
      v-bind="schema.attributesTextField"
      v-model="value"
      :rules="rules"
      :name="schema.model"
      :id="setId(schema.model)"
      :ref="schema.model"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
    >
      <template v-slot:label>
        {{ schema.attributesTextField.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>

      <template v-slot:selection="{ text }" v-if="schema.attributesChips.visible">
        <v-chip v-bind="schema.attributesChips">{{ text }}</v-chip>
      </template>
    </v-file-input>

    <template v-else>
      <v-hover v-slot:default="{ hover }" v-if="document && isImages">
        <v-card :elevation="hover ? 12 : 2" v-bind="schema.attributesFile.card">
          <v-img :src="image" v-bind="schema.attributesFile.image">
            <v-row v-if="hover" align="center" justify="center" class="hover-card-image">
              <v-col cols="12">
                <v-card-text v-text="schema.attributesTextField.label" class="text-h5 font-weight-bold"></v-card-text>
                <v-card-text>{{ document.fileName }}</v-card-text>
                <v-card-text class="font-weight-bold">{{ document.size }}</v-card-text>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn text icon dark v-on="on" @click="deleteDocument()">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Deletar Arquivo</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn text icon dark v-on="on" @click="downloadDocument()">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                  </template>
                  <span>Baixar Arquivo</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-img>
        </v-card>
      </v-hover>

      <v-card v-if="document && !isImages" v-bind="schema.attributesFile.card">
        <v-card-title class="text-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon large left v-on="on">{{ document.contentType }}</v-icon>
            </template>
            <span>{{ document.fileName }}</span>
          </v-tooltip>

          <span class="text-h6 font-weight-light">{{ document.size }}</span>
        </v-card-title>

        <v-card-text class="text-h5 font-weight-bold" v-text="schema.attributesTextField.label"></v-card-text>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row align="center" justify="end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn text icon v-on="on" @click="deleteDocument()">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>Deletar Arquivo</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn text icon v-on="on" @click="downloadDocument()">
                    <v-icon>get_app</v-icon>
                  </v-btn>
                </template>
                <span>Baixar Arquivo</span>
              </v-tooltip>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import * as HANDLERS from '@/helpers/types/handlers';
import { formatBytes, getIcon, downloadFile } from '@/helpers/utils';
import store from '@/store';
import inputEventsMixin from '@/mixins/input-events-mixin';
import validatorAcceptInputFileMixin from '@/mixins/validator-accept-input-file-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, validatorAcceptInputFileMixin],

  data() {
    return {
      isThumbnail: false,
      isImages: false,
      document: null,
      image: null
    };
  },

  created() {
    this.configurationThumbnail();
  },

  methods: {
    configurationThumbnail() {
      let fileName = this.model[`${this.schema.model}_filename`];
      let contentType = this.model[`${this.schema.model}_content_type`];
      let size = this.model[`${this.schema.model}_size`];

      if (fileName && contentType && size) {
        this.isThumbnail = true;

        this.createThumbnail(fileName, contentType, size);
      }
    },

    createThumbnail(fileName, contentType, size) {
      this.document = {
        content: this.model[this.schema.model],
        size: formatBytes(size),
        fileName: fileName,
        contentType: getIcon(contentType)
      };

      this.isImages = contentType.includes('image/');

      if (this.isImages) {
        this.image = `data:${contentType};base64,${this.model[this.schema.model]}`;
      }
    },

    deleteDocument() {
      this.value = [];
      this.isThumbnail = false;
      this.image = null;
    },

    downloadDocument() {
      downloadFile(
        this.document.content,
        this.model[`${this.schema.model}_content_type`],
        this.document.fileName.split('.').pop(),
        this.document.fileName.split('.').shift()
      );
    },

    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    },

    async onBlur() {
      this.changeEvents();
    }
  },

  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) this.configurationThumbnail();

      if (newValue) {
        const validAccept = this.validatorAcceptInputFile(this.schema.attributesTextField, newValue);

        if (validAccept)
          setTimeout(() => {
            this.value = null;
          }, 10);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-responsive__content {
  transition: 300ms;
  .hover-card-image {
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.6);
    transition: 300ms;

    div {
      color: #fff;
      text-align: center;
      padding: 0 0 10px 0;
    }
  }
}
</style>
